import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../../_state';
import AnalysisApps from './AnalysisApps';
import AnalysisAgent from './AnalysisAgent';

export default function AnalysisSales() {
  const [selectedTab, setSelectedTab] = useState('agent');

  const auth = useRecoilValue(authAtom);

  const handleChangeTab = async (event, newValue) => {
    // await setSrchData({ ...srchData, isDohwa: true });
    setSelectedTab(newValue);
  };

  return (
    <Box>
      <Tabs value={selectedTab} onChange={handleChangeTab} textColor="secondary" indicatorColor="secondary" sx={{ mb: 1 }}>
        <Tab label="Agent" value="agent" />
        <Tab label="도화앱스" value="sales" />
      </Tabs>

      {selectedTab === 'agent' && <AnalysisAgent />}
      {selectedTab === 'sales' && <AnalysisApps />}
    </Box>
  );
}
